// services/caixas/caixas.service.ts
import { API } from "../api";
import type {
  Caixa,
  CaixaPayload,
  RegistrarCaixaResponse,
  UpdateCaixaResponse,
} from "./caixas.types";

/**
 * GET /verCaixas
 */
export const getCaixas = async (): Promise<Caixa[]> => {
  const { data } = await API.get<Caixa[]>("/verCaixas");
  return data;
};

/**
 * POST /registrarCaixa
 */
export const registrarCaixa = async (
  payload: CaixaPayload,
): Promise<RegistrarCaixaResponse> => {
  const { data } = await API.post<RegistrarCaixaResponse>(
    "/registrarCaixa",
    payload,
  );
  return data;
};

/**
 * PUT /editarCaixa/{id}
 */
export const editarCaixa = async (
  id: number,
  payload: CaixaPayload,
): Promise<UpdateCaixaResponse> => {
  const { data } = await API.put<UpdateCaixaResponse>(
    `/editarCaixa/${id}`,
    payload,
  );
  return data;
};

/**
 * DELETE /excluirCaixa/{id}
 */
export const excluirCaixa = async (id: number): Promise<void> => {
  await API.delete(`/excluirCaixa/${id}`);
};
